import styled from 'styled-components'

export const Title = styled.h1`
  font-family: Mulish;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 20px;
  color: var(--text-tertiary);
  margin-top: 1em;
`

export const Description = styled.h3`
  font-family: Mulish;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  color: var(--text-tertiary);
  margin-top: 1.7em;
`
